<template>
  <Survey isMSDCustom :customCompanyId="customCompanyId">
  </Survey>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import Survey from '../index.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'

export default {
  beforeRouteEnter (to, from, next) {
    const pagePath = from.fullPath
    const ignorePathList = [
      '/recruiting/agreement-checking',
      '/recruiting/personal/resume/add',
      '/passport/'
    ]
    if (from.meta?.survey?.ignorePath || _.some(ignorePathList, ignorePath => pagePath.startsWith(ignorePath))) {
      next()
    } else {
      next(vm => {
        if (pagePath && pagePath !== '/') {
          vm.setFromPath(pagePath)
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    const pagePath = to.fullPath
    const ignorePathList = [
      '/recruiting/agreement-checking',
      '/recruiting/personal/resume/add',
      '/passport/'
    ]
    if (to.meta?.survey?.ignorePath || _.some(ignorePathList, ignorePath => pagePath.startsWith(ignorePath))) {
      next()
    } else {
      this.setFromPath(null)
      next()
    }
  },
  components: {
    Survey
  },
  metaInfo () {
    return {
      title: '加入默沙东人才社区'
    }
  },
  data () {
    return {
      companyId: ROOT_COMPANY_ID.MSD,
      surveyInfo: {
        company: {},
        survey: {}
      }
    }
  },
  computed: {
    customCompanyId () {
      if (this.$route.meta?.customCompanyId) {
        return this.$route.meta?.customCompanyId
      }
      return this.companyId
    }
  },
  created () {
  },
  methods: {
    ...mapActions('survey', ['setFromPath'])
  }
}
</script>

<style lang="scss" scoped>
</style>
